export const enum QueryKey {
  COTIZATION_FLOW = "cotization-flow"
}
